import { Alert, Avatar, Box, Button, CircularProgress, Grid, Paper, Stack, Typography } from "@mui/material";
import { DragEvent, useState } from "react";
import { stringAvatar, stringToColor } from "../../user/avatarUtils";
import { useNavigate } from "react-router";
import { useAppDispatch } from "../../../app/hooks";
import { ImageInsTargetRequest, imageInsert, selectImageIns } from "../../../redux/image/imageInsSlice";
import { useSelector } from "react-redux";
import { LoadState } from "../../../redux/common";
import { PRIZA_THEME } from "../../..";

export interface ElementUploadImageProps {
    currentImage: string;
    name: string;
    backTo: string;
    backCleanup?: () => void;
    target: ImageInsTargetRequest;
}

export function ElementUploadImage(props: ElementUploadImageProps) {
    const [dragOver, setDragOver] = useState(false);
    // determines if the image is being loaded in the component
    // const [loading, setLoading] = useState(false);
    // determines if some image was loaded, and it can be uploaded
    const [loaded, setLoaded] = useState(false);
    const [file, setFile] = useState(undefined as any);
    const [imagePreview, setImagePreview] = useState(props.currentImage);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const newImage = useSelector(selectImageIns);

    const errorMessage = (newImage.state.state == LoadState.Failed)
        ? <Alert severity="error">Erro ao carregar imagem</Alert>
        : <></>;
    
    const handleCancel = () => {
        if(props.backCleanup)
            props.backCleanup();
        navigate(props.backTo);
    };

    if(newImage.state.state == LoadState.Loaded) {
        // after executing the service, it's like to cancel and back
        handleCancel();
    }

    const handleDrag = (event: DragEvent) => {
        event.stopPropagation();
        event.preventDefault();
        const target = (event.target as HTMLDivElement);
        console.log(`drag ${target.id} : ${event.type}`);
        setDragOver(event.type === "dragover");
    };
  
    const handleDrop = (event: any) => {
        event.preventDefault();
        console.log(`drop ${event.target.id}`);
        setDragOver(false);
        const files = event.dataTransfer.files;
        if (files && files[0]) {
            handleFileChange(files[0]);
        }
    };

    const handleFileChange = (file: any) => {
        // setLoading(true);
        setLoaded(false);
        const reader = new FileReader();
        reader.onloadend = () => {
            setFile(file);
            // setLoading(false);
            setLoaded(true);
            if(reader && reader.result && typeof reader.result === "string")
                setImagePreview(reader.result);
        };
        reader.readAsDataURL(file);
    };

    const handleChange =  (event: any) => {
        console.log(`change ${event.target.id}`);
        const files = event.target.files;
        if (files && files[0]) {
            handleFileChange(files[0]);
        }
    };

    const handleSubmit = () => {
        console.log(`Submit ${file?.name}`);
        dispatch(imageInsert({file, target: props.target}));
    };

    const avatar =
        <Box sx={{ mr: 2 }}>
            <Avatar sx={{ backgroundColor: stringToColor(props.name) }} alt={`${props.name}`} src={imagePreview}>
                <Typography variant="h6" component="span">
                {stringAvatar(props.name)}
                </Typography>
            </Avatar>
        </Box>;
    
    const avatarSize = {xs: 80, sm: 120};
    const avatar2 = <Avatar sx={{ width: avatarSize, height: avatarSize, backgroundColor: stringToColor(props.name) }} variant='square' alt={`${props.name}`} src={imagePreview}>
              <Typography sx={{ fontSize: {xs: "2rem", sm: "4rem"} }}>
                {stringAvatar(props.name)}
              </Typography>
            </Avatar>;

    const controls = (newImage.state.state == LoadState.Loading)
        ?   <>
                <CircularProgress size={20}/>
            </>
        :   <>
                <Button onClick={handleCancel} variant='contained' color='error' sx={{ mt: 3, ml: 1 }}> Cancelar </Button>
                <Button variant="contained" onClick={handleSubmit} sx={{ mt: 3, ml: 1 }} disabled={!loaded} > Confirmar </Button>
            </>;

    return <>
        <Paper id="paper" elevation={3} sx={{ p: 2, mx: {xs: 2, sm: 10} }}
            onDragOver={handleDrag} onDragLeave={handleDrag} onDrop={handleDrop}
            style={{ borderColor: dragOver ? PRIZA_THEME.palette.secondary.main : PRIZA_THEME.palette.primary.main, 
                    borderStyle: dragOver ? "dashed" : "dashed",
            padding: 20, textAlign: "center", cursor: "pointer", position: "relative",
            background: PRIZA_THEME.palette.background.paper,  }} >
            <Grid container justifyContent="center" style={{ marginBottom: 16 }}>
                <input accept="image/*" style={{ display: "none" }} id="raised-button-file" type="file" onChange={handleChange} />
                <label htmlFor="raised-button-file">
                    <Box display="flex" flexDirection="column" alignItems="center">
                        <Stack direction="row" spacing={2} alignItems="center">
                        {avatar} {avatar2}
                        </Stack>
                    </Box>
                </label>
            </Grid>
            <Typography>Arraste uma imagem para esta caixa, ou click para selecionar uma imagem</Typography>
        </Paper>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
            {controls}
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
            {errorMessage}
        </Box>
    </>;
}
